import { isLocalEnvironment } from "@constants/environment"

export const AUTO_CLOSE_MODAL_MILLISECONDS = 1000

export const MODAL_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  NOTIFICATION: "notification",
  CONFIRM: "confirm",
} as const

export const FLG = {
  ON: 1,
  OFF: 0,
} as const

export const TYPE_OPTION = {
  FIRST: 1,
  SECOND: 2,
} as const

export const SORT_DIRECTION = {
  ASCEND: "asc",
  DESCEND: "desc",
} as const

export const SORT_DIRECTION_INVERTER = {
  ASC: "ascend",
  DESC: "descend",
} as const

export const DATE_TIME = {
  SLASH_DD_MM_YYYY_HH_MM_SS: "DD/MM/YYYY HH:mm:ss",
  SLASH_YYYY_MM_DD_HH_MM_SS: "YYYY/MM/DD HH:mm:ss",
  SLASH_YYYY_MM_DD_WEEKDAY: "YYYY/MM/DD（dd）",
  SLASH_YYYY_MM_DD: "YYYY/MM/DD",
  SLASH_YYYY_MM: "YYYY/MM",
  ISO_YYYY_MM_DD: "YYYY-MM-DD",
  ISO_YY_MM_DD: "YY-MM-DD",
  ISO_YYYY_MM: "YYYY-MM",
  ISO_MM_DD: "MM-DD",
  ISO_D_M: "D-M",
  ISO_M_D: "M-D",
  ISO_YYYY_MM_DD_HH_MM_SS: "YYYY-MM-DD HH:mm:ss",
  ISO_YYYY_MM_DD_HH_MM: "YYYY-MM-DD HH:mm",
  HH_MM: "HH:mm",
  H_MM: "H:mm",
  M_D_JA: "MM月DD日",
} as const

export const TIME_UNITS = {
  DAYS: "days",
  HOURS: "hours",
  MINUTES: "minutes",
  SECONDS: "seconds",
  MILLISECONDS: "milliseconds",
  MONTHS: "months",
  YEARS: "years",
  DATES: "dates",
} as const
const appAssetsUrl = process.env.APP_ASSETS_URL

export const REACT_WEB_ASSETS = {
  PATH_IMAGE: !isLocalEnvironment() && appAssetsUrl ? new URL("/images", appAssetsUrl).href : "/images",
}

export const DATA_NULL = "---"

export const APP_LOCALE = process.env.APP_LOCALE || "ja"

export const ERROR_CODE = {
  ERR_NETWORK: "ERR_NETWORK",
  ERR_BAD_REQUEST: "ERR_BAD_REQUEST",
  ERR_BAD_RESPONSE: "ERR_BAD_RESPONSE",
  ECONNABORTED: "ECONNABORTED",
} as const

export const DEVICE_CODE_KEY = "X-Device-Code"

export const SIGNAGE_CATALOG_TYPE = {
  MAKER: 1,
  RANKING: 2,
  TAG: 3,
} as const

export const RANKING_DISPLAY_LIMIT = 10

export const RANKING_DISPLAY_IMAGE_TOP_NUMBER = 3

export const SIGNAGE_PAGE_IDLE_TIMEOUT_MINUTE = 5

export const SIGNAGE_MAX_ZOOM_SCALE = 3

export const SIGNAGE_MIN_ZOOM_SCALE = 1

export const SIGNAGE_PRINTING_MODAL_AUTO_CLOSE_MILLISECONDS = 3000

export const PRINT_COMMAND_TIMEOUT_MILLISECONDS = 10000

export const PRODUCT_LIST_PAGE_SIZE = 50

export const MAX_PRODUCT_MEDIA_COUNT = 4

export const MEDIA_MODULE_TYPE = {
  PRODUCT: "product",
  ADVERTISEMENT: "advertisement",
} as const

export const MAX_UPLOAD_SIZE_MB: Record<string, number | Record<string, number>> = {
  image: 5,
  video: 50,
  text: 50,
}

export const MIN_ADVERTISEMENT_DURATION = 2

export const MAX_ADVERTISEMENT_DURATION = 30

export const MAX_FILTER_JAN_CODE_LENGTH = 20

export const DEFAULT_PAGE_PARAMS = {
  page: 1,
  per_page: PRODUCT_LIST_PAGE_SIZE,
}
